<mat-toolbar class="matero-toolbar">
  @if (showToggle) {
  <button mat-icon-button (click)="toggleSidenav.emit()">
    <mat-icon>menu</mat-icon>
  </button>
  }

  @if (showBranding) {
  <app-branding></app-branding>
  }


  <!--  TODO FIX header profile-->
  <span class="flex-fill"></span>

  <div *ngIf="isAuth()" class="row">
    <h1>{{name()}}</h1>
    <button mat-icon-button (click)="exit()">
      <mat-icon>exit_to_app</mat-icon>
    </button>
  </div>

  <div *ngIf="!isAuth()" class="row" routerLink="/auth/login" style="vertical-align: center">
    <h1 style="color: red">Авторизоваться</h1>
    <button mat-icon-button routerLink="/auth/login">
      <mat-icon>account_circle</mat-icon>
    </button>
  </div>


  <!--  <button mat-icon-button>-->
  <!--    <mat-icon>search</mat-icon>-->
  <!--  </button>-->

  <!--  <button mat-icon-button class="hide-small" (click)="toggleFullscreen()">-->
  <!--    <mat-icon>fullscreen</mat-icon>-->
  <!--  </button>-->

  <!--  <app-notification class="hide-small"></app-notification>-->

  <!--  <app-translate></app-translate>-->

  <!--  <app-user></app-user>-->

  <!--  <button mat-icon-button class="hide-small" (click)="toggleSidenavNotice.emit()">-->
  <!--    <mat-icon>list</mat-icon>-->
  <!--  </button>-->
</mat-toolbar>
